import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const ConnectIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M18.258 5.492a2.85 2.85 0 0 1 0 4.03l-2.563 2.564 1.272 1.273 2.564-2.563a4.65 4.65 0 0 0-6.576-6.577l-2.652 2.652a4.9 4.9 0 0 0 0 6.93l.353.353 1.273-1.273-.353-.353a3.1 3.1 0 0 1 0-4.384l2.651-2.652a2.85 2.85 0 0 1 4.03 0Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M5.742 18.008a2.85 2.85 0 0 1 0-4.03l2.563-2.564-1.272-1.273-2.564 2.564a4.65 4.65 0 0 0 6.576 6.576l2.652-2.652a4.9 4.9 0 0 0 0-6.93l-.353-.353-1.273 1.273.353.353a3.1 3.1 0 0 1 0 4.384l-2.651 2.652a2.85 2.85 0 0 1-4.03 0Z"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M18.258 5.492a2.85 2.85 0 0 1 0 4.03l-2.563 2.564 1.272 1.273 2.564-2.563a4.65 4.65 0 0 0-6.576-6.577l-2.652 2.652a4.9 4.9 0 0 0 0 6.93l.353.353 1.273-1.273-.353-.353a3.1 3.1 0 0 1 0-4.384l2.651-2.652a2.85 2.85 0 0 1 4.03 0Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M5.742 18.008a2.85 2.85 0 0 1 0-4.03l2.563-2.564-1.272-1.273-2.564 2.564a4.65 4.65 0 0 0 6.576 6.576l2.652-2.652a4.9 4.9 0 0 0 0-6.93l-.353-.353-1.273 1.273.353.353a3.1 3.1 0 0 1 0 4.384l-2.651 2.652a2.85 2.85 0 0 1-4.03 0Z"
              }
            )
          ]
        }
      );
    }
    console.error(
      `ConnectIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { ConnectIcon };
//# sourceMappingURL=ConnectIcon.mjs.map
